// The viewer's Chat filter setting (on unless switched off): swearing in chat and messages shows as asterisks.
// Slurs and hate speech already arrive as asterisks from the server (shared/hate-filter.ts).
import { maskSwears } from '../shared/hate-filter.ts';
import { S } from './state.ts';

export function chatShown(text: string): string {
  return S.trainer?.settings.chatFilter === false ? text : maskSwears(text);
}
